export enum MutationTypes {
  SET_QR_CODES = "qr-code-module/set-qr-codes",
  SET_QR_CODES_META = "qr-code-module/set-qr-codes-meta",
  SET_QR_CODES_FOR_CSV = "qr-code-module/set-qr-codes-for-csv",
}
